module.exports = __webpack_public_path__ + "static/media/map-icon.1e2e89ed.svg";